import { render, staticRenderFns } from "./Head-sticky.vue?vue&type=template&id=4ad67106&scoped=true"
import script from "./Head-sticky.vue?vue&type=script&lang=js"
export * from "./Head-sticky.vue?vue&type=script&lang=js"
import style0 from "./Head-sticky.vue?vue&type=style&index=0&id=4ad67106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad67106",
  null
  
)

export default component.exports